import React from 'react';
import ReactDOM from 'react-dom';
import HeaderBG from '../components/HeaderBG';
import HomeFooter from '../components/HomeFooter';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {observer} from 'mobx-react';
import cyan500 from 'material-ui/styles/colors';
import HomeHeader from '../components/HomeHeader';

@observer(['state','actions'])
// var ContactUs = React.createClass({
export default class ContactUs extends React.Component {


	constructor(props) {
	    super(props);
	    this.state = {
	    	'name': 			"",
	    	'email': 			"",
	    	'company': 			"",
	    	'message': 			"",
	    	'type': 			"",
	    	'statusMsg': 		"",
	    };
	    this.errorMsg = 'this field is required';
	    this.errorMsgEmail = 'Email not valid';
	    this.emailErr = "";
	    this.nameErr = ""
	    this.messageErr = "";
	    this.small_device = window.screen.availWidth < 768 ? true : false;
	}

	componentDidMount(){
		// console.log("track page");
		window.analytics.page('ContactUs');
	}


	checkEmailAddress(email){
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	checkInput(){

		this.emailErr = "";
		this.nameErr = "";
		this.messageErr = "";

		if(!this.state.name || !this.state.email || !this.state.message || !this.checkEmailAddress(this.state.email) ){

			if(!this.state.name) this.nameErr = this.errorMsg;
			if(!this.state.email || !this.checkEmailAddress(this.state.email)) this.emailErr = this.errorMsgEmail;
			if(!this.state.message) this.messageErr = this.errorMsg;

			this.forceUpdate();
			return false;
		}
		else{

			this.forceUpdate();
			return true;
		}
	}

	clearFields(){
		this.setState({'name':"",'email':"",'company':"",'message':""});
	}

	handleSubmit(event){
		if(this.checkInput()){
			this.setState({ type: 'info', statusMsg: 'Sending...' }, this.sendFeedback);
		}
	}

	sendFeedback(){
		var _this = this;
		this.props.actions.user.sendFeedback(this.state).then(function(res){
        	_this.sentSuccess(res);
        },function(err){
        	_this.sentError(err);
        });
        this.clearFields();

	}

	sentSuccess(res){
		this.setState({ type: 'success', statusMsg: 'Thank You! We have received your message and will respond promptly.' });
		console.log('feedback sent',res);
	}

	sentError(err){
		this.setState({ type: 'danger', statusMsg: 'Sorry, there has been an error. Please try again later' });
		console.log('feedback error',err);
	}

	handleChange(fieldName,event) {

		var change = {};
		change[fieldName] = event.target.value;
	    this.setState(change);
	}

	render(){

		// var
		if (this.state.type && this.state.statusMsg) {
		    var classString = 'alert alert-' + this.state.type;

		    if(this.state.type == "success"){
		    	var img = <img className="check_img" src={require("../../img/check.png")}/>
		    	var status = <div id="status" className={classString} ref="status">
		    				   {img}
		    	               {this.state.statusMsg}
		    	             </div>;
	         }else{
	         	var status = <div id="status" className={classString} ref="status">
	         	               {this.state.statusMsg}
	         	             </div>;
	         }

		}
		return (
			<div>
				<HomeHeader/>
				<HeaderBG></HeaderBG>
				<div className="container contact_us">
					<div className="row">

						<div className="col-md-6">
							<h1 className="black_text">Let us know what you think</h1>
							<div className="green_line"></div>
							<p className="dark_text">
								We are here to provide you with more information<br/>
								and answer any question you may have.
							</p>

						</div>
						<div className="col-md-6">

							{status}
							<TextField
								className="tipigo_bright_input"
								underlineFocusStyle={{"borderColor":"#47b927"}}
								value={this.state.name}
							    onChange={this.handleChange.bind(this,'name')}
							    errorText={this.nameErr}
							    fullWidth={this.small_device}
								floatingLabelText="Name"/>
							<TextField
								className="tipigo_bright_input float_left_xs"
								underlineFocusStyle={{"borderColor":"#47b927"}}
								value={this.state.email}
							    onChange={this.handleChange.bind(this,'email')}
							    errorText={this.emailErr}
							    fullWidth={this.small_device}
								style={{"float":"right"}} floatingLabelText="Email"/>
							<br/>
							<TextField
								className="tipigo_bright_input"
								underlineFocusStyle={{"borderColor":"#47b927"}}
								value={this.state.company}
							    onChange={this.handleChange.bind(this,'company')}
							    fullWidth floatingLabelText="Company"/>
							<br/>
							<TextField
								className="tipigo_bright_input"
								underlineFocusStyle={{"borderColor":"#47b927"}}
								value={this.state.message}
								multiLine
							    onChange={this.handleChange.bind(this,'message')}
							    errorText={this.messageErr}
								fullWidth floatingLabelText="Message"/>
							{/*<div className ={ this.messageErr !== "" ? "has-error" + " form-group label-floating" : "form-group label-floating" } >
				                <label for="c_message" className="control-label">Message</label>
				                <textarea id="c_message"
			                	value={this.state.message}
			                    onChange={this.handleChange.bind(this,'message')}
				                className="form-control " ></textarea>
				                <span className="help-block">{this.messageErr}</span>
				            </div>*/}
							<br/>
							<br/>
							<br/>
							<RaisedButton className="feedback_btn" onClick={this.handleSubmit.bind(this)} fullWidth label="SUBMIT" labelColor="white" backgroundColor="rgb(71,185,39)" />
							<br/>
							<br/>
							<br/>
						</div>
					</div>

				</div>
				{/* <HomeFooter></HomeFooter> */}
			</div>
		)

	}
}



// WEBPACK FOOTER //
// ./src/js/pages/ContactUs.js